import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  return (
    <Link to={`/product/${product.id}`} className="product-card fade-in">
      <div className="product-image-container">
        <img 
          src={product.image} 
          alt={product.name}
          className="product-image"
          loading="lazy"
        />
        {product.featured && (
          <span className="product-badge">Featured</span>
        )}
      </div>
      
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-name-jp">{product.nameJp}</p>
        <div className="product-footer">
          <span className="product-price">DA{product.price.toLocaleString()}</span>
          <span className="product-category">{product.category}</span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
